/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Box, Flex } from 'grid-styled'
import { fetchDashboardResume } from 'alelo-logic/actions'
import Button from '../../elements/Button'
import Advertisement from './Advertisement'
import Content from 'styles/objects/Content'
import Hide from 'styles/utilities/Hide'
import PlanResume from '../../modules/PlanResume'
import ConsumptionChart from '../../modules/ConsumptionChart'
import ConsumptionChartPos from '../../modules/ConsumptionChartPos'
import DashboardCashDisplay from '../../modules/DashboardCashDisplay'
import DashboardIdentifierList from '../../modules/DashboardIdentifierList'
import rem from 'styles/tools/rem'
import { setLoading } from '../../modules/PageLoader/actions'
import { Icon } from 'app/elements/Icon'
import {
  Separator,
  LinkBanner,
  ModalIllustration,
  ModalTitle,
  ModalDescription,
  WrapperModal
} from './styles'
import DashboardInvoiceWidget from '../../modules/DashboardInvoiceWidget'
import PageLoader from '../../modules/PageLoader'
import InfoCarousel from './InfoCarousel'

import imagemBanner from '../../../static/carro-veloe.png'

import { rechargeButtonLabel } from './data.json'
import Warning from './Warning'
import Modal from 'app/elements/Modal'

// import image from '../../../static/icon-veloe-background.svg'

import { skyBlue } from '/styles/settings/colors'

import { gqlQuery } from '../../../alelo-logic/services/common/apolloClient'
import { gqlTotalIdentificadores } from '../../../alelo-logic/services/queries/vehicles'
import ModalDesligamento from '../../elements/ModalDesligamento'

class DashboardResume extends Component {
  state = {
    modalBanner: false,
    qtdTag: '0'
  }

  async componentDidMount() {
    this.props.setLoading(true)
    await this.props.fetchResume(this.props.match.params.id)
    await this.getWarnTags(this.props.match.params.id)
    const qtdTag = await this.props.getTotalTags(this.props.match.params.id)
    this.setState({ qtdTag: qtdTag || '0' })
  }

  async shouldComponentUpdate(nextProps) {
    const hasPlanChange =
      this.props.accountPlans.activePlanId !== nextProps.accountPlans.activePlanId
    if (hasPlanChange) {
      this.props.setLoading(true)
      await this.props.fetchResume(this.props.match.params.id)
      await this.getWarnTags(this.props.match.params.id)
    }

    return true
  }

  componentWillUnmount() {
    return <InfoCarousel />
  }

  getWarnTags(identifierId) {
    const listTagsWarn = JSON.parse(sessionStorage.getItem('warnTags'))
    this.setState({
      modalBanner: listTagsWarn && parseInt(listTagsWarn.conta) === parseInt(identifierId)
    })
  }

  goIdentifier() {
    this.props.history.push(`/minha-veloe/${this.props.match.params.id}/identificadores`)
  }

  closeModal = () => {
    this.setState({ modalBanner: false })
  }

  modalChangeTag() {
    return (
      <WrapperModal>
        <Modal background={skyBlue} hideModal={this.closeModal}>
          <ModalTitle>
            <Icon icon="info" width="34" height="34" viewBox="0 0 24 24" />
            Você precisa trocar sua tag
          </ModalTitle>
          <ModalDescription>
            Vimos que em algum momento a cancela não abriu pra você.<br />
            <LinkBanner onClick={() => this.goIdentifier()}>Clique aqui</LinkBanner>
            {''} ou vá até <b>"Minhas Veloetags"</b>, substitua as tags sinalizadas.<br />
            Evite ficar parado, troque agora.
          </ModalDescription>
          <ModalIllustration src={imagemBanner} />
        </Modal>
      </WrapperModal>
    )
  }

  render() {
    const { resume, accountPlans, history, match, account: { accountType } } = this.props
    const { modalBanner, qtdTag } = this.state

    const isPartner = (this.props.account || {}).pc

    if (!resume || !resume.type) {
      return null
    }

    let obj =
      accountPlans && accountPlans.plans && accountPlans.plans.length > 0
        ? accountPlans.plans.find(el => el && el.id === match.params.id)
        : null

    if (this.props.account.at) {
      history.push(`/minha-veloe/identificadores-parceiros`)
      return true
    }
    if (
      resume &&
      resume.vehicles &&
      resume.vehicles.length === 0 &&
      obj &&
      obj.identifiers &&
      obj.identifiers.length <= 0 &&
      obj.identifiersOrders.length > 0
    ) {
      history.push(`/minha-veloe/${match.params.id}/identificadores/acompanhar-pedido`)
    }

    const finantialData = resume.consumption || resume.balance || {}

    const currentAccountPlan =
      (accountPlans && accountPlans.plans.find(plan => plan.id == match.params.id)) || {} // eslint-disable-line
    const currentPlan = currentAccountPlan.plan || {}
    const isPrePaid = currentPlan && currentPlan.type === 'pre'

    return (
      <section>
        <PageLoader>
          <Content>
            {resume && (
              <Flex mt={[0, rem('35px')]} mb={rem('60px')} align="stretch" wrap={[true, false]}>
                <Box mb={[rem('20px'), 0]} pr={[0, 20]} width={[1, 3 / 12]}>
                  <PlanResume qtdTag={qtdTag} />
                </Box>
                <Box pl={[0, 20]} width={[1, 9 / 12]}>
                  <DashboardCashDisplay
                    recharge={isPrePaid}
                    updateDate={finantialData.date}
                    value={obj ? (!isPrePaid ? obj.availableAmount : obj.ammount) : null}
                    isPartner={isPartner}
                  />
                  {isPrePaid && <Separator />}
                  {isPrePaid ? (
                    <ConsumptionChart consumption={resume.consumption} balance={resume.balance} />
                  ) : (
                    <ConsumptionChartPos
                      consumption={resume.balance}
                      balance={resume.balance}
                      currentPlan={currentAccountPlan}
                      accountType={(this.props.account || {}).pc}
                    />
                  )}
                  {isPrePaid && (
                    <Hide at="large" mt={rem('20px')}>
                      <Button
                        id="button-manual-recharge"
                        onClick={() => history.push(`/minha-veloe/${match.params.id}/recarga`)}
                        text={rechargeButtonLabel}
                      />
                    </Hide>
                  )}
                  {!isPrePaid && (
                    <div>
                      <Separator />
                      <DashboardInvoiceWidget
                        currentAccountPlan={currentAccountPlan}
                        match={match}
                        isPartner={isPartner}
                      />
                    </div>
                  )}
                  <Separator />
                  <DashboardIdentifierList
                    accountPlans={accountPlans}
                    resume={resume}
                    isPartner={isPartner}
                  />
                  <InfoCarousel>
                    <Warning.IrrfAutoRetencao />
                    <Warning.Toll />
                    <Warning.CheckApp />
                    <Warning.Signalization />
                    {accountType === 'pf' && <Advertisement />}
                  </InfoCarousel>
                </Box>
              </Flex>
            )}
          </Content>
        </PageLoader>
        {modalBanner && this.modalChangeTag()}
        <ModalDesligamento />
      </section>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  resume: reducer.dashboardResume,
  accountPlans: reducer.accountPlans,
  account: reducer.account
})

const mapDispatchToProps = dispatch => ({
  fetchResume: (token, planId) =>
    dispatch(fetchDashboardResume(token, planId))
      .then()
      .finally(() => dispatch(setLoading(false))),
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  },
  getTotalTags: async idConta => {
    const { data: { identificadoresPJV2: { paginacao: { total } } } } = await gqlQuery(
      gqlTotalIdentificadores,
      { idConta }
    )
    return total
  },
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardResume)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardResume/index.js